import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { LoadingComponent } from './pages/loading/loading.component';
import { OnboardingComponent } from './pages/onboarding/onboarding.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthActionComponent } from './pages/auth-action/auth-action.component';
import { authGuard } from './common/guards/auth.guard';
import { BriefsComponent } from './pages/briefs/briefs.component';
import { MyBrandComponent } from './pages/my-brand/my-brand.component';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { ViewSubmissionComponent } from './pages/view-submission/view-submission.component';
import { BriefResultsComponent } from './pages/brief-results/brief-results.component';
import { ManageBriefTabsComponent } from './pages/manage-brief-tabs/manage-brief-tabs.component';
import { manageBriefTabsMatcher } from './pages/manage-brief-tabs/manage-brief-tab.routing';
import { CreateBriefAgentComponent } from './pages/create-brief-agent/create-brief-agent.component';
import { InboxFullComponent } from './pages/inbox-full/inbox-full.component';
import { ScreeningBriefsComponent } from './pages/screening-briefs/screening-briefs.component';
import { ScreeningBriefCreateComponent } from './pages/screening-brief-create/screening-brief-create.component';
import { ManageTokensComponent } from './pages/manage-tokens/manage-tokens.component';
import { ScreeningBriefResultsComponent } from './pages/screening-brief-results/screening-brief-results.component';
import { CreatorsV2Component } from './pages/creators-v2/creators-v2.component';
import { ScreeningBriefReportComponent } from './pages/screening-brief-report/screening-brief-report';
import { BrandProductsRakutenComponent } from './pages/my-brand/molecules/brand-products-rakuten/brand-products-rakuten.component';
import { OnboardingV2Component } from './pages/onboarding-v2/onboarding-v2.component';
import { LoggedOutComponent } from './pages/logged-out/logged-out';
import { ThankyouBrand } from './pages/thankyou-brand/thankyou-brand';
import { ThankyouAgency } from './pages/thankyou-agency/thankyou-agency';
import { BriefEnhancementsComponent } from './pages/brief-enhancements/brief-enhancements.component';
import { BriefAutoHireConfigComponent } from './pages/brief-auto-hire-config/brief-auto-hire-config.component';
import { TikTokBusinessCallbackComponent } from './pages/tiktok-business-callback/tiktok-business-callback.component';
import { CreatorsV4Component } from './pages/creators-v4/creators-v4.component';
import { CreatorsV4FilterComponent } from './pages/creators-v4-filter/creators-v4-filter.component';
import { CreatorsMyGroups } from './pages/creators-my-groups/creators-my-groups';
import { GroupShare } from './pages/group-share/group-share';
import { WalletV2 } from './pages/wallet-v2/wallet-v2';
import { sandboxBillingGuard } from './shared/guards/sandbox-billing.guard';
import { InsightsLayout } from './pages/insights/layout/insights-layout';
import { BrandList } from './pages/insights/tabs/brand/brand-list/brand-list';
import { Brand } from './pages/insights/tabs/brand/brand';
import { Profile as BrandProfile } from './pages/insights/tabs/brand/atoms/profile/profile';
import { Billing as BrandBilling } from './pages/insights/tabs/brand/atoms/billing/billing';
import { Team as BrandTeam } from './pages/insights/tabs/brand/atoms/team/team';
import { Visits as BrandVisits } from './pages/insights/tabs/brand/atoms/visits/visits';
import { PricingModels as BrandPricingModels } from './pages/insights/tabs/brand/atoms/pricing-models/pricing-models';
import { Affiliate as BrandAffiliate } from './pages/insights/tabs/brand/atoms/affiliate/affiliate';
import { Appless as BrandAppless } from './pages/insights/tabs/brand/atoms/appless/appless';
import { Agency } from './pages/insights/tabs/agency/agency';
import { Brief } from './pages/insights/tabs/brief/brief';
import { BriefList } from './pages/insights/tabs/brief/brief-list/brief-list';
import { BriefDetailsTab } from './pages/insights/tabs/brief/molecules/details/details';
import { BriefApplications } from './pages/insights/tabs/brief/molecules/applications/applications';
import { VideoModeration } from './pages/insights/tabs/video-moderation/video-moderation';
import { CreatorList } from './pages/insights/tabs/creator/creator-list/creator-list';
import { Creator } from './pages/insights/tabs/creator/creator';
import { CreatorProfile } from './pages/insights/tabs/creator/molecules/profile/profile';
import { CreatorActivities } from './pages/insights/tabs/creator/molecules/activities/activities';
import { CreatorSocials } from './pages/insights/tabs/creator/molecules/socials/socials';
import { CreatorPayouts } from './pages/insights/tabs/creator/molecules/payouts/payouts';
import { CreatorMediaKit } from './pages/insights/tabs/creator/molecules/media-kit/media-kit';
import { Monitoring } from './pages/monitoring/monitoring';
import { CreateMonitoringBrief } from './pages/monitoring/molecules/create-monitoring-brief/create-monitoring-brief';
import { ManageBriefTabsMonitor } from './pages/manage-brief-tabs-monitor/manage-brief-tabs-monitor';
import { OnboardingSelect } from './pages/onboarding-select/onboarding-select';
import { OnboardingAgency } from './pages/onboarding-agency/onboarding-agency';
import { OnboardingCreator } from './pages/onboarding-creator/onboarding-creator';
import { OnboardingValueFirst } from './pages/onboarding-value-first/onboarding-value-first';
import { OnboardingQuickBrief } from './pages/onboarding-quick-brief/onboarding-quick-brief';
import { ValueFirstAgency } from './pages/value-first-agency/value-first-agency';
import { AdminOptions } from './pages/admin-options/admin-options';
import { AdminBranding } from './pages/admin-options/branding/admin-branding';
import { AdminCancellations } from './pages/admin-options/cancellations/admin-cancellations';
import { adminCancellationsRoutes } from './pages/admin-options/cancellations/admin-cancellations.routes';
import { adminBrandingRoutes } from './pages/admin-options/branding/admin-branding.routes';
import { AdminGoogleAnalytics } from './pages/admin-options/google-analytics/admin-google-analytics';
import { adminGoogleAnalyticsRoutes } from './pages/admin-options/google-analytics/admin-google-analytics.routes';
import { AdminSettings } from './pages/admin-options/settings/admin-settings';
import { adminSettingsRoutes } from './pages/admin-options/settings/admin-settings.routes';
import { UserProfile } from './pages/admin-options/pages/user-profile/user-profile';
import { BusinessProfile } from './pages/admin-options/pages/business-profile/business-profile';
import { GodModeOptions } from './pages/god-mode-options/god-mode-options';
import { PricingModelsCreate } from './pages/god-mode-options/tabs/pricing-models-create/pricing-models-create';
import { NotAllowedComponent } from './pages/not-allowed/not-allowed.component';
import { DashboardV2Component } from './pages/dashboard-v2/dashboard-v2';
import { ManageBriefTabsScreen } from './pages/manage-brief-tabs-screen/manage-brief-tabs-screen';
import { NotActive } from './page/not-active/not-active';
import { SubscriptionRequired } from './page/subscription-required/subscription-required';
import { UserDisabled } from './pages/user-disabled/user-disabled';
import { CreateBriefSelect } from './pages/create-brief-select/create-brief-select';
import { CreatorPaymentDetails } from './pages/insights/tabs/creator/sections/payment-details';
import { CreatorMonitorInquiry } from './pages/manage-brief-tabs-monitor/molecules/mon-creators/molecules/creator-monitor-inquiry/creator-monitor-inquiry';
import { ScreeningBriefSelect } from './pages/screening-brief-select/screening-brief-select';
import { SupportComponent } from './pages/support/support.component';
import { SupportNewTicketComponent } from './pages/support/support-new-ticket/support-new-ticket.component';
import { SupportTicketThreadComponent } from './pages/support/support-ticket-thread/support-ticket-thread.component';
import { SupportAdminComponent } from './pages/support-admin/support-admin.component';
import { SupportAdminTicketComponent } from './pages/support-admin/support-admin-ticket/support-admin-ticket.component';
import { BookDemo } from './pages/book-demo/book-demo';
import { CreateBriefSelectSmart } from './pages/create-brief-select-smart/create-brief-select-smart';
import { BriefsV2 } from './pages/briefs-v2/briefs-v2';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: ({ queryParams }) => {
            const search = new URLSearchParams();
            for (const [key, value] of Object.entries(queryParams)) {
                const serialized = Array.isArray(value) ? value[0] : value;
                if (serialized != null && serialized !== '') {
                    search.set(key, String(serialized));
                }
            }
            const qs = search.toString();
            return qs.length > 0 ? `/loading?${qs}` : '/loading';
        },
    },
    { path: 'loading', component: LoadingComponent },
    { path: 'login', component: LoginComponent },
    { path: 'auth-action', component: AuthActionComponent },
    { path: 'book-demo', component: BookDemo },
    
    /**
     *  Onboarding Options
     * 1. Always use "onboarding-select" as the route for the active onboarding page.
     * 2. 1 October: 
     * Current -> OnboardingValueFirst
     * Previous -> OnboardingSelect
     */
    // { path: 'onboarding-select', component: OnboardingSelect },
    { path: 'onboarding-select', component: OnboardingValueFirst },
    // { path: 'signup', component: OnboardingValueFirst },


    { path: 'onboarding', component: OnboardingV2Component },
    { path: 'onboarding-quick-brief', component: OnboardingQuickBrief },
    { path: 'onboarding-agency', component: OnboardingAgency },
    { path: 'onboarding-value-first-agency', component: ValueFirstAgency },
    { path: 'onboarding-creator', component: OnboardingCreator },
    { path: 'logged-out', component: LoggedOutComponent },
    // { path: 'onboarding', component: OnboardingComponent },
    { path: 'dashboard', component: DashboardV2Component, canActivate: [authGuard] },
    {
      path: 'shout-plus-intro',
      loadComponent: () => import('./pages/shout-plus-intro/shout-plus-intro').then((m) => m.ShoutPlusIntro),
      canActivate: [authGuard],
    },
    // { path: 'creators', component: CreatorsComponent, canActivate: [authGuard] },
    { path: 'creators', component: CreatorsV2Component, canActivate: [authGuard] },
    { path: 'creators-v4', component: CreatorsV4Component, canActivate: [authGuard] },
    { path: 'creators-v4-filter', component: CreatorsV4FilterComponent, canActivate: [authGuard] },
    { path: 'creators-v4-filter/:briefId', component: CreatorsV4FilterComponent, canActivate: [authGuard] },
    // { path: 'creators/:briefId', component: CreatorsComponent, canActivate: [authGuard] },
    { path: 'creators/:briefId', component: CreatorsV2Component, canActivate: [authGuard] },
    { path: 'creators-my-groups', component: CreatorsMyGroups, canActivate: [authGuard] },
    { path: 'groups/share/:token', component: GroupShare },
    { path: 'r/:token', loadComponent: () => import('./pages/public-report/public-report').then((m) => m.PublicReportPage) },
    // { path: 'briefs', component: BriefsComponent, canActivate: [authGuard] },
    { path: 'briefs', component: BriefsV2, canActivate: [authGuard] },
    { path: 'screening', component: ScreeningBriefsComponent, canActivate: [authGuard] },
    { path: 'screening-brief-create', component: ScreeningBriefCreateComponent, canActivate: [authGuard] },
    // Creator lists became recruit groups; creating one happens in My Groups now.
    { path: 'screening-creator-list-create', redirectTo: 'creators-my-groups', pathMatch: 'full' },
    { path: 'screening-brief-results/:briefId', component: ScreeningBriefResultsComponent, canActivate: [authGuard] },
    { path: 'screening-brief-report/:briefId/:creatorId', component: ScreeningBriefReportComponent, canActivate: [authGuard] },
    { path: 'my-account', component: MyAccountComponent, canActivate: [authGuard] },
    { path: 'my-brand', redirectTo: '/my-brand/business-info', pathMatch: 'full' },
    { path: 'cancel-subscription', loadComponent: () => import('./pages/cancel-subscription/cancel-subscription').then((m) => m.CancelSubscription), canActivate: [authGuard] }, 
    { path: 'my-brand/:tab', component: MyBrandComponent, canActivate: [authGuard] },
    { path: 'my-agency', loadComponent: () => import('./pages/my-agency/my-agency.component').then((m) => m.MyAgencyComponent), canActivate: [authGuard] },
    { path: 'wallet', redirectTo: 'wallet-v2', pathMatch: 'full' },
    { path: 'wallet-v2', component: WalletV2, canActivate: [authGuard, sandboxBillingGuard] },
    { path: 'manage-tokens', component: ManageTokensComponent, canActivate: [authGuard] },
    { path: 'manage-brief-old/:briefId', redirectTo: '/manage-brief/:briefId' },
    {
      path: 'manage-brief',
      canActivate: [authGuard],
      children: [
        {
          matcher: manageBriefTabsMatcher,
          component: ManageBriefTabsComponent,
        },
      ],
    },
    { path: 'brief-enhancements/:briefId', component: BriefEnhancementsComponent, canActivate: [authGuard] },
    { path: 'brief-auto-hire-config/:briefId', component: BriefAutoHireConfigComponent, canActivate: [authGuard] },
    { path: 'manage-results/:briefId', component: BriefResultsComponent, canActivate: [authGuard] },
    { path: 'manage-results/:briefId/:tab', component: BriefResultsComponent, canActivate: [authGuard] },
    { path: 'view-submission/:briefId/:creatorId', component: ViewSubmissionComponent, canActivate: [authGuard] },
    { path: 'create-agent-brief', component: CreateBriefAgentComponent, canActivate: [authGuard] },
    { path: 'create-brief-select', component: CreateBriefSelect, canActivate: [authGuard] },
    { path: 'create-brief-select-smart', component: CreateBriefSelectSmart, canActivate: [authGuard] },
    { path: 'screening-brief-select', component: ScreeningBriefSelect, canActivate: [authGuard] },
    { path: 'inbox', component: InboxFullComponent, canActivate: [authGuard] },
    { path: 'rakuten-products/:action', component: BrandProductsRakutenComponent, canActivate: [authGuard] },
    { path: 'thankyou-brand', component: ThankyouBrand, canActivate: [authGuard] },
    { path: 'thankyou-agency', component: ThankyouAgency, canActivate: [authGuard] },
    {
        path: 'insights',
        component: InsightsLayout,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'brand', pathMatch: 'full' },
            {
                path: 'brand',
                component: BrandList,
                children: [
                    {
                        path: ':businessAccountId',
                        component: Brand,
                        children: [
                            { path: '', redirectTo: 'profile', pathMatch: 'full' },
                            { path: 'profile', component: BrandProfile },
                            { path: 'billing', component: BrandBilling },
                            { path: 'team', component: BrandTeam },
                            { path: 'visits', component: BrandVisits },
                            { path: 'pricing_models', component: BrandPricingModels },
                            { path: 'affiliate', component: BrandAffiliate },
                            { path: 'appless', component: BrandAppless },
                        ],
                    },
                ],
            },
            { path: 'agency', component: Agency },
            { path: 'agency/:agencyId', component: Agency },
            {
                path: 'brief',
                component: BriefList,
                children: [
                    {
                        path: ':briefId',
                        component: Brief,
                        children: [
                            { path: '', redirectTo: 'details', pathMatch: 'full' },
                            { path: 'details', component: BriefDetailsTab },
                            { path: 'applications', component: BriefApplications },
                        ],
                    },
                ],
            },
            { path: 'video-moderation', component: VideoModeration },
            {
                path: 'creator',
                component: CreatorList,
                children: [
                    {
                        path: ':creatorId',
                        component: Creator,
                        children: [
                            { path: '', redirectTo: 'profile', pathMatch: 'full' },
                            { path: 'profile', component: CreatorProfile },
                            { path: 'activities', component: CreatorActivities },
                            { path: 'socials', component: CreatorSocials },
                            { path: 'payouts', component: CreatorPayouts },
                            { path: 'media-kit', component: CreatorMediaKit },
                            { path: 'payment-details', component: CreatorPaymentDetails },
                        ],
                    },
                ],
            },
        ],
    },
    { path: 'admin-options', component: AdminOptions, canActivate: [authGuard] },
    {
        path: 'admin-options/branding',
        component: AdminBranding,
        canActivate: [authGuard],
        children: adminBrandingRoutes,
    },
    {
        path: 'admin-options/cancellations',
        component: AdminCancellations,
        canActivate: [authGuard],
        children: adminCancellationsRoutes,
    },
    {
        path: 'admin-options/google-analytics',
        component: AdminGoogleAnalytics,
        canActivate: [authGuard],
        children: adminGoogleAnalyticsRoutes,
    },
    {
        path: 'admin-options/settings',
        component: AdminSettings,
        canActivate: [authGuard],
        children: adminSettingsRoutes,
    },
    { path: 'admin-options/user-profile/:userId', component: UserProfile, canActivate: [authGuard] },
    { path: 'admin-options/business-profile/:businessAccountId', component: BusinessProfile, canActivate: [authGuard] },
    { path: 'admin-options/:tabId', component: AdminOptions, canActivate: [authGuard] },
    { path: 'god-mode-options', component: GodModeOptions, canActivate: [authGuard] },
    { path: 'god-mode-options/:tabId', component: GodModeOptions, canActivate: [authGuard] },

    { path: 'support', component: SupportComponent, canActivate: [authGuard] },
    { path: 'support/new', component: SupportNewTicketComponent, canActivate: [authGuard] },
    { path: 'support/tickets/access/:token', component: SupportTicketThreadComponent },
    { path: 'support/tickets/:id', component: SupportTicketThreadComponent, canActivate: [authGuard] },
    { path: 'support-admin', component: SupportAdminComponent, canActivate: [authGuard] },
    { path: 'support-admin/:ticketId', component: SupportAdminTicketComponent, canActivate: [authGuard] },

    { path: 'monitoring', component: Monitoring, canActivate: [authGuard] },
    // Creator lists were consolidated into recruit groups. The migration reused each
    // list's uuid as the group id, so old deep links resolve without translation.
    { path: 'creator-list-details/:listId', redirectTo: 'creators-my-groups', pathMatch: 'full' },
    { path: 'create-monitoring-brief/:type', component: CreateMonitoringBrief, canActivate: [authGuard] },
    { path: 'manage-brief-monitor/:briefId', component: ManageBriefTabsMonitor, canActivate: [authGuard] },
    { path: 'manage-brief-monitor/:briefId/:tab', component: ManageBriefTabsMonitor, canActivate: [authGuard] },
    { path: 'creator-inquiry/:inquiryId', component: CreatorMonitorInquiry, canActivate: [authGuard] },
    { path: 'manage-brief-screen/:briefId', component: ManageBriefTabsScreen, canActivate: [authGuard] },
    { path: 'manage-brief-screen/:briefId/:tab', component: ManageBriefTabsScreen, canActivate: [authGuard] },
    { path: 'create-pricing-model', component: PricingModelsCreate, canActivate: [authGuard] },
    { path: 'not-allowed', component: NotAllowedComponent },
    { path: 'user-disabled', component: UserDisabled },
    { path: 'subscription-paused', component: NotActive },
    { path: 'subscription-required', component: SubscriptionRequired },
    {
        path: 'shout-plus',
        loadChildren: () => import('./shout-plus/shout-plus.module').then((m) => m.ShoutPlusModule),
        canActivate: [authGuard],
    },
    { matcher: tikTokBusinessCallbackMatcher, component: TikTokBusinessCallbackComponent },
];

export function tikTokBusinessCallbackMatcher(segments: UrlSegment[]): UrlMatchResult | null {
    if (segments.length >= 1 && segments[0].path.startsWith('tiktok-business-callback')) {
        return { consumed: segments };
    }
    return null;
}
